// extracted by mini-css-extract-plugin
export default {"MainLoadAnim":"styles_MainLoadAnim__tFNB9","LoadTile":"styles_LoadTile__5TKDw","fadeA":"styles_fadeA__gMeyM","fadeB":"styles_fadeB__iCwGV"};